import { useEffect } from 'react';
import MessageService from 'message-service/message-service';
import MlbNativeWrapper, { MLB_NATIVE_NAVCLICK } from '../MlbNativeWrapper';

export const useNavClickProxy = (cb) => {  
    useEffect(() => { 
        if (cb && typeof cb === 'function') {

            MlbNativeWrapper.then(() => {
                MessageService.on(MLB_NATIVE_NAVCLICK, cb);
            });
        }
        return () => {
            if (cb) {
                MessageService.off(MLB_NATIVE_NAVCLICK, cb);
            }
        };
    }, [MessageService, cb]);
    return null
}
